import React, { useState } from 'react'
import { Spin } from 'antd'
import BulkSelect from './BulkSelect'
import BulkActions from './BulkActions'
import BatchesErrorRows from './BatchesErrorRows'


const ItemPieceErrorTable = ({ loading, listBatchesError, refreshBatches, handleChangeProductType, handleChangeBrand }) => {
    const [loadingSend, setLoadingSend] = useState(false)
    const [selectedItems, setSelectedItems] = useState([])
    const [isSelectedAll, setSelectedAll] = useState(false)

    const _toggleSelectAll = (isChecked) => {
        if (isChecked) {
            const itemIds = listBatchesError.map(item => item._id)
            setSelectedItems(itemIds)
            setSelectedAll(true)
        } else {
            setSelectedItems([])
            setSelectedAll(false)
        }
    }

    const _handleSendLoading = (value) => {
        setLoadingSend(value)
    }

    const _updateSelectedOrders = (id, value) => {
        if (value && !selectedItems.includes(id)) {
            setSelectedItems([...selectedItems, id])
            setSelectedAll(selectedItems.length + 1 === listBatchesError.length)
        } else {
            const filtered = selectedItems.filter(itemId => itemId !== id)
            setSelectedItems(filtered)
            setSelectedAll(false)
        }
    }

    return (
        <div className='ItemPieceErrorTable'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className='thead-light'>
                        {loadingSend ? (
                            <tr>
                                <BulkSelect isSelectedAll={isSelectedAll} selectedItems={selectedItems} loadingSend={loadingSend} toggleSelectAll={_toggleSelectAll} />
                                <th colSpan={11} className="position-relative">
                                    Sending...
                                </th>
                            </tr>
                        ) : selectedItems.length > 0 ? (
                            <tr>
                                <BulkSelect isSelectedAll={isSelectedAll} selectedItems={selectedItems} loadingSend={loadingSend} toggleSelectAll={_toggleSelectAll} />
                                <th colSpan={11} className="position-relative">
                                    <BulkActions refreshBatches={refreshBatches} listBatchesError={listBatchesError} selectedItems={selectedItems} toggleSelectAll={_toggleSelectAll} handleSendLoading={_handleSendLoading} setSelectedItems={setSelectedItems}/>
                                </th>
                            </tr>
                        ) : (
                            <tr>
                                <BulkSelect
                                    isSelectedAll={isSelectedAll}
                                    selectedItems={selectedItems}
                                    loadingSend={loadingSend}
                                    toggleSelectAll={_toggleSelectAll}
                                />
                                <th className='Name'>Tên lô</th>
                                <th className="colDate">Ngày tạo</th>
                                <th className="Product-type">Loại sản phẩm</th>
                                <th className="Status">Trạng thái lô</th>
                                <th className="text-center Quantity">Số lượng item lỗi</th>
                                <th className='CuttingAt'>Ngày cắt</th>
                                <th className='Partner'>Đối tác in ép</th>
                                <th className="Partner">Đối tác may</th>
                                <th className="HumanCreate">Người tạo</th>
                                <th className="Note">Ghi chú</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {
                            listBatchesError.length > 0 ? (
                                listBatchesError.map(item => {
                                    return (
                                        <BatchesErrorRows 
                                            key={item._id} item={item}
                                            loadingSend={loadingSend} 
                                            handleSendLoading={_handleSendLoading} 
                                            selectedItems={selectedItems} 
                                            updateSelectedOrders={_updateSelectedOrders}
                                            onChangeProductType={handleChangeProductType} 
                                            handleChangeBrand={handleChangeBrand}
                                        />
                                    )
                                }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={10}>No data</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default ItemPieceErrorTable